import { type App, type Component } from 'vue'
import * as components from './components/LabsContent'

const LabsContentPlugin = {
  installed: false,

  install(app: App) {
    if (this.installed) {
      return
    }

    this.installed = true

    for (const key in components) {
      app.component(key, (components as Record<string, Component>)[key])
    }
  },
}

export * from './components/LabsContent'

export default LabsContentPlugin
